module.exports = __webpack_public_path__ + "img/logo-sm.f83d645a.png";